import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

import { ref, onMounted, provide } from 'vue'
import { useRouter } from 'vue-router'
import { msalInstance, loginRequest } from '@/auth/msalInstance'
import { api } from '@/services/api'
import type Client from '@/models/client'
import TopBar from '@/components/layout/TopBar.vue'
import SideNav from '@/components/layout/SideNav.vue'
import LoginView from '@/components/auth/LoginView.vue'

// Constants

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const colors = {
  PRIMARY: '#714FE3',
  ACCENT: '#F29B00',
  NEUTRAL: '#FFFFFF',
  SECONDARY: ['#D0ED77', '#D284EF', '#39288C']
}

// Reactive state
const isAuthenticated = ref(false)
const loading = ref(false)
const clientMenuItems = ref<Client[]>([])
const searchQuery = ref('')
const filteredClients = ref<Client[]>([])
const menu = ref(false)
const router = useRouter()

// Authentication methods
const checkAuth = async () => {
  const accounts = msalInstance.getAllAccounts()
  isAuthenticated.value = accounts.length > 0
}

const handleLogin = async () => { // todo aram kinda wanna move this to the login view
  loading.value = true
  console.log("redirectUri from window:", window.location.origin);
  try {
    await msalInstance.loginPopup(loginRequest)
    await checkAuth()
    const redirectPath = sessionStorage.getItem('redirectPath') || '/'
    console.log("redirectPath:", redirectPath);
    sessionStorage.removeItem('redirectPath')
    router.push(redirectPath)
  } catch (error) {
    console.error('Login failed:', error)
  } finally {
    loading.value = false
  }
}

const handleLogout = async () => {
  loading.value = true;
  try {
    await msalInstance.logoutPopup();
    isAuthenticated.value = false;
    router.push('/login');
  } catch (error) {
    console.error('Logout failed:', error);
  } finally {
    loading.value = false;
  }
};

// Methods
const filterClients = () => {
  filteredClients.value = clientMenuItems.value.filter(client =>
    client.name.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
}

const selectClient = (client: Client) => {
  menu.value = false;
  router.push(`/client/${client.id}`);

  setTimeout(() => {
    filteredClients.value = clientMenuItems.value;
    searchQuery.value = '';
  }, 300);
}

const showActivityHistory = () => {
  router.push('/activity-history')
}

const getClients = async () => {
  try {
    const clients = await api.getClients() as Client[]
    clientMenuItems.value = clients
    filteredClients.value = clients
    console.log('Clients:', clients)
  } catch (error) {
    console.error('Error fetching clients:', error)
  }
}

// Lifecycle hooks
onMounted(async () => {
  await checkAuth()
  if (isAuthenticated.value) {
    filteredClients.value = clientMenuItems.value
    getClients()
  }
})

// Make getClients available to child components
provide('refreshClients', getClients)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (isAuthenticated.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(TopBar, { onLogout: handleLogout }),
            _createVNode(SideNav, {
              "client-menu-items": clientMenuItems.value,
              "filtered-clients": filteredClients.value
            }, null, 8, ["client-menu-items", "filtered-clients"]),
            _createVNode(_component_v_main, {
              style: _normalizeStyle({ background: colors.NEUTRAL })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            }, 8, ["style"])
          ], 64))
        : (_openBlock(), _createBlock(LoginView, {
            key: 1,
            loading: loading.value,
            colors: colors,
            onLogin: handleLogin
          }, null, 8, ["loading"]))
    ]),
    _: 1
  }))
}
}

})